export default __webpack_public_path__ + "static/media/mc_screen_default.7893f1af.svg";